<template>
  <div class="my-role content-box" style="flex-wrap: wrap; width: 60%">
    <!-- <loading :active="loading" background-color="transparent" /> -->
    <div class="tab_role">
      <center v-if="!loading && jueseList.length <= 0">
        <img src="@/assets/images/null.png" />
      </center>
      <div
        class="tab_box"
        style="width: 20%; margin: 5px 0"
        v-for="(item, i) in jueseList"
        :key="i + 'juese'"
        @click="ModelCheck(item)"
      >
        <div
          class="tab_item tab_item_5"
          :class="{ tab_active: item.rolesId == user.rolesId }"
          :style="{ 'background-image': 'url(' + item.rolesPhoto + ')' }"
          style="
            background-position: center;
            background-size: auto 100%;
            background-repeat: no-repeat;
          "
        >
          <div class="tab_bottom live2d_share">
            {{ item.type == 1 ? "DB" : item.type == 2 ? "live2d" : "3D" }} ·
            共享
          </div>
          <div
            class="right-card"
            v-if="
              item.platform.length > 0 &&
              item.platform[0].isCommercial &&
              item.platform[0].isCommercial == 1
            "
            style=""
          >
            <span>允许商用</span>
          </div>
          <!-- :class="item.type==1?'db_share':'live2d_share'" -->
          <!-- <img :src="item.rolesPhoto" alt=""> -->

          <!-- <div class="tab_edit">
                        <div><i class="iconfont icon-remove-1-copy"></i><span>编辑</span>  </div>
                        <div  @click="delUserModel(item.rolesId)"><i class="iconfont icon-bianji"></i><span>删除</span> </div>
                    </div> -->
        </div>
        <div class="rolesname">{{ item.rolesName }}</div>
      </div>

      <div
        @click="morePage()"
        v-if="isShowLoad > 0 && !showEdit"
        style="margin: 10px 0; text-align: center; width: 100%; cursor: pointer"
      >
        <!-- margin-top: 30px; -->
        {{ loadtxt }}
      </div>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/components/util/util_fun.js'
export default {
  name: 'Background',
  props: ['modelClass', 'user'],
  data () {
    return {
      action: [],//动画列表
      jueseList: [],
      showEdit: false,
      loading: true,
      isShowLoad: false,
      param: {
        uid: this.$store.state.userinfo.userId,
        searchText: "",
        pageIndex: 0,
        pageSize: 20,
        sort: 2,//2是倒叙，1是时间正序
        modelId: "",//模型id
        type: "",//模型类型 0.龙骨 1.live3D
        sex: "",//性别 1.男 2.女
        isCommercial: '', // // 是否商用 0:false 1:true
      }
    }
  },
  created () {

    this.initParam()
  },
  methods: {

    //初始化
    initParam () {
      this.param.pageIndex = 0
      this.getUserModelList()
    },
    //获取用户角色模型
    getUserModelList (searchText, isCommercial) {
      if (searchText) {
        this.param.searchText = searchText
        this.param.pageIndex = 0
      }
      if (isCommercial != undefined) {
        this.param.isCommercial = isCommercial
        this.param.pageIndex = 0
      } else {
        // delete this.param.isCommercial
      }
      this.loading = true
      var that = this

      this.post("/platform/findPlatformRoles", this.param).then((res) => {
        that.loading = false
        // console.log(res.data)
        if (res.status == "200") {
          var data = res.data[0]
          this.count = res.data[1]
          for (var a = 0; a < data.length; a++) {
            data[a].isHad = false
            data[a].createDate = formatDate(new Date(data[a].createDate), 'yyyy-MM-dd')
          }
          // that.jueseList=data;
          if (this.param.pageIndex == 0) {
            that.jueseList = data
          } else {
            that.jueseList = that.jueseList.concat(data)
          }
          var pageIndex = JSON.parse(JSON.stringify(that.param.pageIndex))
          if (((pageIndex + 1) * that.param.pageSize) >= that.count) {
            that.isShowLoad = false
            that.loadtxt = ''
          } else {

            that.isShowLoad = true
            that.loadtxt = '点击加载更多'
          }

        } else {
        }
      })
        .catch(() => {
          that.loading = false
        })
    },
    //分页
    morePage () {
      var pageIndex = JSON.parse(JSON.stringify(this.param.pageIndex))

      if (((pageIndex + 1) * this.param.pageSize) >= this.count) {

      } else {
        this.param.pageIndex++
        this.getUserModelList()
      }
    },
    ModelCheck (user) {
      // this.$emit("ModelCheck", user)
      // console.log("角色中心预览", user)
      // return
      this.post("/secret/getEncryptionInfo", {
        typeId: user.rolesId,
        type: 1
      }).then((res) => {
        if (res.status == "200") {
          if (res.data) {
            user.key = res.data
          }
          console.log("获得秘钥", user)
          this.$emit("ModelCheck", user)
          this.$emit('checkRole', user)

        }
        else {
          this.$message.error("获得秘钥失败")
        }
      })
        .catch((e) => {

        })
    },


  }
}
</script>
<style lang="scss" scoped>
.tab_role {
  height: 780px;
  &::-webkit-scrollbar-thumb {
    display: unset;
    // @include background("scrollbar");
    background: #f0829b69;
  }
}
.right-card {
  position: absolute;
  right: 10px;
  top: 10px;
  background: #d0d0d0b5;
  border-radius: 30px;
  padding: 0 5px;
  font-size: 12px;
}
@media screen and (max-height: 630px) {
  .tab_role {
    height: 540px;
  }
}
@media screen and (min-height: 650px) and (max-height: 730px) {
  .tab_role {
    height: 650px;
  }
}
</style>
